import { RedoAlert } from "@redotech/arbiter/alert/redo-alert";
import { Flex } from "@redotech/arbiter/flex";
import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { Text } from "@redotech/arbiter/text";
import { RedoToggle } from "@redotech/arbiter/toggle/redo-toggle";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { numberValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const exchangeOutboundLabelCreditSettingsForm = groupInput({
  enabled: input<boolean>(),
  amount: input<string>({ validator: numberValidator({ min: 0 }) }),
});

export type ExchangeOutboundLabelCreditSettingsForm = InputSchema.Input<
  typeof exchangeOutboundLabelCreditSettingsForm
>;

export const ExchangeOutboundLabelCreditSettingsCard = memo(
  function ExchangeOutboundLabelCreditSettingsCard({
    input,
  }: {
    input: ExchangeOutboundLabelCreditSettingsForm;
  }) {
    return (
      <>
        <RedoAlert
          color="warning"
          description="Redo pays this credit. It applies only when an order being exchanged has Redo returns coverage. Confirm the arrangement with finance before enabling."
          fullWidth
          size="sm"
          title="Finance approval required"
        />
        <Flex align="center" dir="row" gap="md" justify="space-between">
          <Flex dir="column" gap="xs" grow="1">
            <Text fontSize="sm" textColor="secondary">
              Each processed exchange credits the merchant this fixed amount on
              their invoice as an Exchange outbound label credit, but only when
              an order being exchanged has Redo returns coverage. Exchanges of
              orders without returns coverage are skipped.
            </Text>
          </Flex>
          <RedoToggle
            setValue={input.inputs.enabled.setValue}
            size="md"
            value={input.inputs.enabled.value}
          />
        </Flex>

        <Flex dir="column" gap="md">
          <RedoTextInput
            IconTrailing={() => <Text as="span">USD</Text>}
            label="Credit per covered exchange"
            min={0}
            placeholder="0.00"
            setValue={input.inputs.amount.setValue}
            state={!input.inputs.enabled.value ? "disabled" : "default"}
            step={0.01}
            value={input.inputs.amount.value}
          />
          {input.inputs.amount.errors.length > 0 && (
            <Text fontSize="xs" textColor="error">
              {input.inputs.amount.errors[0]}
            </Text>
          )}
        </Flex>
      </>
    );
  },
);
